export default "__VITE_ASSET__C3dDhDzg__"